import { UseToastOptions } from "@chakra-ui/react"
import { EntityId } from "@jackfruit/common"

// shared context to allow saga functions to get the
// current page id as soon as possible without awaiting for
// useEffect to trigger which can cause sync issues for some components
// when navigating from one page to the other
let currentPageId: EntityId = 0
let toast: (options: UseToastOptions) => {}
let translate: (key: string) => string

export const getCurrentPageId = () => currentPageId
export const setCurrentPageId = (newPageId: EntityId) => {
  currentPageId = newPageId
}

export const setToaster = (toastFunction: (options: UseToastOptions) => {}) => {
  toast = toastFunction
}

export const getToaster = () => toast

export const setTranslator = (tFunction: (key: string) => string) => {
  translate = tFunction
}

export const getTranslator = () => translate
